import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { FileText, Edit, Trash2 } from 'lucide-react';

export const ActivityLogTab = ({ activityLog }) => {
  return (
    <Card className="border-0 shadow-lg">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2">
          <FileText className="w-5 h-5 text-[#C81D25]" />Historial de Actividad
        </CardTitle>
        <CardDescription>Registro de acciones administrativas</CardDescription>
      </CardHeader>
      <CardContent>
        {activityLog.length === 0 ? (
          <div className="text-center py-16 text-gray-400">
            <FileText className="w-12 h-12 mx-auto mb-4 opacity-30" />
            <p className="text-lg font-medium">No hay actividad registrada aún</p>
            <p className="text-sm">Las acciones de administración aparecerán aquí</p>
          </div>
        ) : (
          <div className="space-y-3">
            {activityLog.map((log) => {
              const ActionIcon = log.action === 'status_change' ? Edit :
                log.action === 'code_deleted' ? Trash2 : FileText;
              const iconColor = log.action === 'status_change' ? 'text-[#C81D25]' :
                log.action === 'code_deleted' ? 'text-red-500' : 'text-gray-500';

              return (
                <div key={log.id} className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                  <div className="w-10 h-10 bg-[#C81D25]/10 rounded-full flex items-center justify-center shrink-0">
                    <ActionIcon className={`w-4 h-4 ${iconColor}`} />
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-gray-900">
                      {log.action === 'status_change' && `Estado cambiado: ${log.old_status} → ${log.new_status}`}
                      {log.action === 'code_deleted' && (log.details || 'Código eliminado')}
                      {!['status_change', 'code_deleted'].includes(log.action) && log.action}
                    </p>
                    {log.reason && <p className="text-xs text-gray-500 mt-1">Razón: {log.reason}</p>}
                    <p className="text-xs text-gray-400 mt-1">{log.admin_email} — {new Date(log.created_at).toLocaleString('es-MX')}</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
